module.exports = __webpack_public_path__ + "img/head.d8ae3133.png";